import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Tooltip,
  Typography,
  styled,
  tooltipClasses,
} from '@mui/material';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import debounce from 'lodash/debounce';
import Cookies from 'js-cookie';
import { get, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useNavigate, useParams } from 'react-router-dom';
import { SelectComponent } from 'src/components/hook-form';
import CareerAutoComplete from 'src/components/AutoComplete/CareerAutoComplete';
import ProgressStepper from 'src/components/ProgressStepper';
import { resetCompare, setAlert, setGlobalCompare } from 'src/layouts/main/MainLayoutSlice';
import RegionStepper from 'src/components/RegionStepper';
import { analytics } from 'src/utils';
import { Icon } from '@iconify/react';
import {
  addCareerGoal,
  addCareerHistory,
  getCareerHistory,
  getRegionBySlug,
  useGetCareerGoalsMutation,
  useGetCareersMutation,
  useGetNestedCareersMutation,
} from './CareerHistorySlice';
import { ArcticonsEmojiSpiderWeb } from '../Reskill_Flow/SpiderIcon';

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'black',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    maxWidth: '220px !important',
  },
}));
export default function CareerHistoryRegion() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const CareerHistoryState = useSelector((state) => state.careerHistory.CareerHistory);
  const CareerGoalState = useSelector((state) => state.careerHistory.CareerGoal);
  const collegeId = useSelector((state) => state.mainLayout.collegeDetails?._id);
  // console.log("params", params)
  // console.log("college ID", collegeId)
  const [CareerOptions, setCareerOptions] = useState([]);
  const [IP, setIp] = useState('');
  const [CareerIds, setCareerIds] = useState();
  const [CareerGoals, setCareerGoals] = useState();
  const [currentRole, setCurrentRole] = useState([]);
  const [careerGoal, setCareerGoal] = useState();
  const [showError, setShowError] = useState(false);
  const [selectFieldCount, setSelectFieldCount] = useState([0]);
  const [innerStepCount, setInnerStepCount] = useState(0);
  const [careerGoalsData, setCareerGoalsData] = useState();
  const [careersData, setCareersData] = useState();
  const [selectedRole, setSelectedRole] = useState('reskill');
  const [getCareers, { isLoading: careersLoading }] = useGetCareersMutation();
  const [getNestedCareers] = useGetNestedCareersMutation();
  const [getCareerGoals, { isLoading: careersGoalsLoading }] = useGetCareerGoalsMutation();
  const [searchInput, setSearchInput] = useState(['']);
  const [fieldOptions, setFieldOptions] = useState({}); // Options per field
  const [fieldLoading, setFieldLoading] = useState({}); // Loading state per field
  const [fieldOpen, setFieldOpen] = useState({}); // Open state per field
  const [searchTimeouts, setSearchTimeouts] = useState({});
  const [data, setData] = useState({});

  const disabledBtn = {
    true: true,
    false: false,
  };
  const CareerHistorySteps = [
    {
      label: 'Career History',
    },
    {
      label: 'Skilldar',
    },
    {
      label: `Career and ${selectedRole === 'reskill' ? 'Reskill' : 'Upskill'} time`,
    },
  ];
  const getIp = async () => {
    const res = await axios.get('https://api.ipify.org/?format=json');
    const Ip = res.data.ip;
    setIp(Ip);
  };
  const isPageReload = () => {
    try {
      const navEntries =
        typeof performance !== 'undefined' && typeof performance.getEntriesByType === 'function'
          ? performance.getEntriesByType('navigation')
          : null;
      if (navEntries && navEntries.length > 0) {
        return navEntries[0].type === 'reload';
      }

      if (performance && performance.navigation) {
        return performance.navigation.type === 1;
      }
    } catch (e) {
      // noop — if detection fails, assume navigation (safer to preserve)
    }
    return false;
  };

  useEffect(() => {
    dispatch(resetCompare());
    if (isPageReload()) {
      localStorage.removeItem('region-career-history');
    }
    // Clear search options on page load
    setFieldOptions({});
  }, [dispatch]);
  useEffect(() => {
    getIp();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(()=>{
  //   if(collegeId && IP){
  //     getCareers();
  //   }
  // },[collegeId, IP])// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (IP || collegeId) {
      getCareersData();
    }
  }, [IP, collegeId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (currentRole && currentRole.length > 0) {
      setShowError(false);
      const ids = currentRole
        .filter(Boolean)
        .map((role) => role?.value)
        .filter(Boolean);
      setCareerIds(ids);
      if (CareerHistoryState?.length > 0) {
        currentRole.map((role) => {
          if (role && role.value) {
            CareerHistoryState.map((item) => {
              if (item && item.value && role.value !== item.value) {
                setCareerGoal('');
              }
              return '';
            });
          }
          return '';
        });
      }
    }
  }, [currentRole]); // eslint-disable-line react-hooks/exhaustive-deps

  const token = Cookies.get('feToken');
  useEffect(() => {
    const regionId = data?._id || Cookies.get('region-id');
    const payload = {
      isRegion: true,
      regionId,
    };

    // Only use stored localStorage when this is NOT a hard reload.
    const allowLocalRestore = !isPageReload();

    if (token && regionId) {
      dispatch(getCareerHistory(payload)).then((response) => {
        if (get(response, 'payload.data.currentCareerIds')) {
          const formattedData = get(response, 'payload.data.currentCareerIds')?.map((career) => {
            if (typeof career === 'string') {
              return { label: undefined, value: career };
            }
            return {
              label: career?.title,
              value: career?._id || career,
            };
          });

          if (allowLocalRestore) {
            const savedCareers = localStorage.getItem('region-career-history');
            if (savedCareers) {
              try {
                const parsedCareers = JSON.parse(savedCareers);
                // If saved careers look more complete than backend's, prefer the saved copy.
                if (Array.isArray(parsedCareers) && parsedCareers.length > formattedData.length) {
                  dispatch(addCareerHistory(parsedCareers));
                  return;
                }
              } catch (error) {
                console.error(error);
              }
            }
          }

          dispatch(addCareerHistory(formattedData));
        }
        if (get(response, 'payload.data.compareCareerIds')) {
          const formattedData = get(response, 'payload.data.compareCareerIds')?.map(
            (career) => career?._id
          );
          dispatch(setGlobalCompare(formattedData));
        }
      });
    } else if (allowLocalRestore) {
      // Try to restore from localStorage only when allowed (not a reload)
      const savedCareers = localStorage.getItem('region-career-history');
      if (savedCareers) {
        try {
          const parsedCareers = JSON.parse(savedCareers);
          dispatch(addCareerHistory(parsedCareers));
        } catch (error) {
          console.error(error);
        }
      }
    }
  }, [token, data?._id, params?.cg_name, dispatch, navigate]); // eslint-disable-line react-hooks/exhaustive-deps
  const { rg_name } = useParams();
  // console.log(rg_name)
  const regions = useSelector((state) => state.careerHistory);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (rg_name) {
      Cookies.set('url-slug', rg_name);
    }
  }, [rg_name]);

  useEffect(() => {
    setLoading(true);
    dispatch(getRegionBySlug(rg_name));
  }, [rg_name, dispatch]);

  useEffect(() => {
    if (regions?.regions) {
      setData(regions?.regions);
      if (!isEmpty(data)) {
        setLoading(false);
        if (regions?.regions?._id) {
          Cookies.set('region-id', regions?.regions?._id);
        }
      }
    }
  }, [regions?.regions, data]);

  const handleChange = (count, e) => {
    if (currentRole.length === count) {
      setCurrentRole((prev) => [...prev, e]);
    } else if (currentRole.length > count) {
      const newState = currentRole.map((item, index) => {
        if (index === count) {
          item = e;
        }
        return item;
      });
      setCurrentRole(newState);
    }
  };

  const addField = () => {
    const fieldCount = selectFieldCount.length;

    // Update all state arrays/objects atomically
    setSelectFieldCount((prev) => [...prev, fieldCount]);
    setSearchInput((prev) => [...prev, '']);
    setCurrentRole((prev) => [...prev, undefined]);

    // Initialize empty state for new field
    setFieldOptions((prev) => ({ ...prev, [fieldCount]: [] }));
    setFieldLoading((prev) => ({ ...prev, [fieldCount]: false }));
    setFieldOpen((prev) => ({ ...prev, [fieldCount]: false }));

    // Clear any existing timeout for this field
    setSearchTimeouts((prev) => {
      if (prev[fieldCount]) {
        clearTimeout(prev[fieldCount]);
      }
      return { ...prev, [fieldCount]: null };
    });
  };

  const removeField = (count) => {
    // Clear timeout for this field before removing
    if (searchTimeouts[count]) {
      clearTimeout(searchTimeouts[count]);
    }

    // Remove from array-based states (simple filter by index)
    setCurrentRole((prev) => prev.filter((_, index) => index !== count));
    setSearchInput((prev) => prev.filter((_, index) => index !== count));

    // Update selectFieldCount - regenerate indices based on remaining fields
    setSelectFieldCount((prev) => {
      const filtered = prev.filter((_, index) => index !== count);
      return filtered.map((_, index) => index); // Reindex from 0
    });

    // Helper function to reindex object states
    const reindexObjectState = (prevState) => {
      const newState = {};
      let newIndex = 0;

      Object.keys(prevState)
        .map((key) => parseInt(key, 10))
        .sort((a, b) => a - b)
        .forEach((originalIndex) => {
          if (originalIndex !== count) {
            newState[newIndex] = prevState[originalIndex];
            newIndex += 1;
          }
        });

      return newState;
    };

    // Reindex all object-based states
    setFieldOptions(reindexObjectState);
    setFieldLoading(reindexObjectState);
    setFieldOpen(reindexObjectState);
    setSearchTimeouts(reindexObjectState);
  };
  const getGoals = async () => {
    await getCareerGoals({
      IP,
      collegeId,
      careerIds: CareerIds,
    })
      .unwrap()
      .then((payload) => setCareerGoalsData(payload))
      .catch((error) =>
        dispatch(
          setAlert({
            open: true,
            msg: error?.data?.msg
              ? `${error?.status}, ${error?.data?.msg}`
              : 'Something went wrong',
          })
        )
      );
  };
  const getCareersData = async () => {
    await getCareers({
      IP,
      collegeId,
    })
      .unwrap()
      .then((payload) => setCareersData(payload))
      .catch((error) =>
        dispatch(
          setAlert({
            open: true,
            msg: error?.data?.msg
              ? `${error?.status}, ${error?.data?.msg}`
              : 'Something went wrong',
          })
        )
      );
  };
  const performSearch = (inputValue, fieldIndex) => {
    // Clear existing timeout for this field
    if (searchTimeouts[fieldIndex]) {
      clearTimeout(searchTimeouts[fieldIndex]);
    }

    const timeoutId = setTimeout(() => {
      setFieldLoading((prev) => ({ ...prev, [fieldIndex]: true }));
      getNestedCareers({ searchTerm: inputValue })
        .unwrap()
        .then((payload) => {
          setFieldOptions((prev) => ({ ...prev, [fieldIndex]: payload || [] }));
        })
        .catch(() => {
          setFieldOptions((prev) => ({ ...prev, [fieldIndex]: [] }));
        })
        .finally(() => {
          setFieldLoading((prev) => ({ ...prev, [fieldIndex]: false }));
        });
    }, 300);

    setSearchTimeouts((prev) => ({ ...prev, [fieldIndex]: timeoutId }));
  };

  const handleInputFocus = (fieldIndex) => {
    // Only clear and reload if the field doesn't have a selected value
    const hasSelectedValue = currentRole[fieldIndex] && currentRole[fieldIndex].value;
    if (!hasSelectedValue) {
      // Clear options and close dropdown when input is focused
      setFieldOptions((prev) => ({ ...prev, [fieldIndex]: [] }));
      setFieldOpen((prev) => ({ ...prev, [fieldIndex]: false }));
      // Clear search input for this field
      setSearchInput((prev) => {
        const updated = [...prev];
        updated[fieldIndex] = '';
        return updated;
      });
      // Small delay to ensure dropdown closes before loading new data
      setTimeout(() => {
        performSearch('', fieldIndex);
      }, 100);
    }
  };

  const handleSearchInputChange = (fieldIndex) => (event, value, reason) => {
    setSearchInput((prev) => {
      const updated = [...prev];
      updated[fieldIndex] = value;
      return updated;
    });

    // Show loading immediately when user types
    if (reason === 'input') {
      setFieldLoading((prev) => ({ ...prev, [fieldIndex]: true }));
      performSearch(value, fieldIndex);
    }

    // If cleared, also clear the selected value
    if (reason === 'clear') {
      setCurrentRole((prev) => {
        const updated = [...prev];
        updated[fieldIndex] = undefined;
        return updated;
      });
      setFieldLoading((prev) => ({ ...prev, [fieldIndex]: false }));
      // Clear search results when input is cleared
      setFieldOptions((prev) => ({ ...prev, [fieldIndex]: [] }));
    }
  };

  const handleClickUpskill = () => {
    if (params?.rg_name) {
      navigate(`/region/${params.rg_name}/upskill/skilldar`);
    } else {
      navigate(`/${params.cg_name}/upskill/skilldar`);
    }
    analytics({
      IP,
      collegeId,
      event: 'UPSKILL_CLICK',
      from: 'Career History',
    });
    dispatch(addCareerHistory(currentRole));
    dispatch(addCareerGoal(careerGoal));
  };
  const handleClickReskill = () => {
    if (currentRole && currentRole.length > 0) {
      localStorage.setItem('region-career-history', JSON.stringify(currentRole));
      analytics({
        IP,
        collegeId,
        event: 'RESKILL_CLICK',
        from: 'Career History',
      });
      dispatch(addCareerHistory(currentRole));
      if (params?.rg_name) {
        navigate(`/region/${params.rg_name}/reskill/skilldar`);
      } else {
        navigate(`/${params.cg_name}/reskill/skilldar`);
      }
    } else {
      setShowError(true);
    }
  };
  const prevStep = () => {
    setInnerStepCount((prev) => prev - 1);
    setSelectedRole('');
  };
  const nextStep = () => {
    setInnerStepCount((prev) => prev + 1);
  };

  useEffect(() => {
    if (CareerHistoryState?.length > 0) {
      // Resolve career titles if missing and careersData is available
      let resolvedCareers = CareerHistoryState;
      if (careersData?.length > 0) {
        resolvedCareers = CareerHistoryState.map((career) => {
          if (career?.value && !career?.label) {
            const foundCareer = careersData.find((c) => c?._id === career?.value);
            return {
              ...career,
              label: foundCareer?.title || 'Unknown Career',
            };
          }
          return career;
        });
        // console.log('🔍 Resolved career titles:', resolvedCareers);
      }

      setCurrentRole(resolvedCareers);
      const newCount = [];
      for (let i = 0; i < resolvedCareers.length; i += 1) {
        newCount.push(i);
      }
      setSelectFieldCount(newCount);
    } else {
      console.log('⚠️ CareerHistoryState is empty or undefined');
    }
  }, [CareerHistoryState, careersData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (CareerGoalState) {
      setCareerGoal(CareerGoalState);
    }
  }, [CareerGoalState]);

  useEffect(() => {
    if (currentRole && currentRole.length > 0 && innerStepCount === 2) {
      getGoals();
    }
  }, [innerStepCount]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (careersData && careersData?.length > 0) {
      let newState = [];
      newState = careersData.map((item) => ({ value: item._id, label: item.title }));
      setCareerOptions(newState);
    }
  }, [careersData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (careerGoalsData) {
      let newState = [];
      newState = careerGoalsData.map((item) => ({ value: item._id, label: item.title }));
      setCareerGoals(newState);
    }
  }, [careerGoalsData]);

  // Cleanup timeouts on unmount
  useEffect(
    () => () => {
      Object.values(searchTimeouts).forEach((timeoutId) => {
        if (timeoutId) clearTimeout(timeoutId);
      });
    },
    [searchTimeouts]
  );
  const getPaddingLeft = (group) => {
    switch (group) {
      case 'career':
        return '16px';
      case 'specialised_role':
        return '32px';
      default:
        return '8px';
    }
  };

  const autocompleteSx = {
    minWidth: { xs: '280px !important', sm: '400px !important', md: '500px !important' },
    maxWidth: '100%',
    '& .MuiInputBase-root': {
      background: '#fff',
      borderRadius: '8px',
      fontSize: { xs: '0.9rem', sm: '1rem' },
      minHeight: { xs: '40px', sm: '44px' },
    },
    '& .MuiInputBase-input': {
      fontSize: { xs: '0.9rem', sm: '1rem' },
      color: '#222',
      padding: { xs: '8px 12px', sm: '10px 14px' },
    },
    '& .MuiAutocomplete-listbox': {
      fontSize: { xs: '0.85rem', sm: '0.95rem' },
      padding: 0,
      maxHeight: { xs: '250px', sm: '300px' },
      overflowY: 'auto',
    },
    '& .MuiAutocomplete-option': {
      paddingTop: { xs: '6px', sm: '8px' },
      paddingBottom: { xs: '6px', sm: '8px' },
      paddingLeft: { xs: '8px', sm: '12px' },
      display: 'flex',
      alignItems: 'center',
      gap: { xs: '6px', sm: '8px' },
      borderBottom: '1px solid #f0f0f0',
      minHeight: { xs: '36px', sm: '40px' },
    },
    '& .MuiAutocomplete-groupLabel': {
      fontSize: { xs: '0.8rem', sm: '0.9rem' },
      fontWeight: 600,
      color: '#555',
      padding: { xs: '6px 8px 3px', sm: '8px 12px 4px' },
      backgroundColor: '#fafafa',
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
  };

  // ...rest of your

  const buttonColor = data?.button?.bgColor;
  const buttonFontColor = data?.button?.color;
  const logo = data?.logo || '';
  const partnerLogos = data?.partnerLogos || [];
  const primaryColor = data?.primaryColor || '';
  const fontColor = data?.fontColor || '';
  const secondaryColor = data?.secondaryColor || '';
  const bgImage = data?.bgImage || '';

  const SpiderIcon = () => (
    <Icon icon="fluent-emoji:spider-web" color={buttonColor} width="36" height="36" />
  );

  const steps = [
    { icon: <AssignmentIcon />, label: 'Career History' },
    {
      icon: <ArcticonsEmojiSpiderWeb width={36} height={36} color={buttonColor} />,
      label: 'Results',
    }, // Capitalized if it's a component
  ];

  return (
    <>
      <Helmet>
        <title>Enter Career History</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          minHeight: '100vh',
          '@media (max-width: 899px)': {
            paddingTop: '20px !important',
          },
        }}
        className="page-content-wrapper career-history-page"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 4 } }}>
          <Box sx={{ pt: { xs: 2, sm: 4, md: 5 } }} className="content">
            {/* <StepperComponent steps={CareerHistorySteps} activeStep={0}/> */}
            <RegionStepper
              steps={steps}
              activeStep={0} // Change to 1 to highlight "Results"
              buttonColor={buttonColor}
              buttonFontColor={buttonFontColor}
            />
            <Box
              className="inner-step-wrapper"
              sx={{
                px: { xs: 0, sm: 2, md: 4 },
                py: { xs: 2, sm: 3, md: 4 },
              }}
            >
              {!careersLoading ? (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      gap: { xs: 2, md: 0 },
                    }}
                  >
                    <Button
                      className="step-btn prev"
                      sx={{
                        overflow: 'hidden',
                        height: innerStepCount > 0 ? 'auto' : 0,
                        color: (theme) => buttonColor || theme.palette.secondary.main,
                        minWidth: { xs: 36, md: 48 },
                        alignSelf: { xs: 'flex-start', md: 'center' },
                        mb: { xs: 1, md: 0 },
                      }}
                      onClick={prevStep}
                    >
                      <ArrowBackIosIcon />
                    </Button>
                    <Box
                      className="content-wrapper career"
                      sx={{
                        background: 'transparent',
                        width: '100%',
                        mx: { xs: 0, md: 2 },
                        borderRadius: { xs: 2, md: 4 },
                        p: { xs: 2, sm: 3, md: 4 },
                        boxShadow: { xs: 'none', md: 2 },
                      }}
                    >
                      {innerStepCount === 0 && (
                        <>
                          <Box className="head">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: { xs: 'column', sm: 'row' },
                                textAlign: { xs: 'center', sm: 'left' },
                              }}
                            >
                              <Typography
                                variant="h1"
                                ml={{ xs: 0, sm: '16px' }}
                                sx={{
                                  color: fontColor,
                                  fontSize: { xs: '28px', sm: '32px', lg: '40px' },
                                  fontFamily: '"Merriweather", serif',
                                  fontWeight: 900,
                                  lineHeight: 1.1,
                                }}
                              >
                                What’s Your Career History?
                              </Typography>
                            </Box>
                            <Typography
                              variant='h2'
                              sx={{
                                color: fontColor,
                                fontSize: '16px !important',
                                fontWeight: 700,
                                fontFamily: '"Work Sans", sans-serif',
                                marginTop: 1,
                                marginBottom: { xs: 3, md: 8 },
                                textAlign: { xs: 'center', sm: 'center' },
                                lineHeight: 1.5,
                              }}
                            >
                              To personalise your journey, we’ll start by looking at the roles
                              you’ve had. Select the job that best matches your current role — or,
                              if you’re not working right now, choose the one you held most
                              recently. Then, add any previous roles you’ve had. This Career History
                              will help us We’ll use this to highlight the skills you’ve developed
                              and show you where they could take you next. Whether you’re looking to
                              reskill for a new direction or upskill to grow in your current
                              organisation, this insight will guide your next steps.
                              <br />
                              <br />
                              When you’re ready, tap Continue to discover your options.
                            </Typography>
                          </Box>

                          <Box className="fields">
                            {selectFieldCount?.map((count, index) => (
                              <Box
                                className="field-wrapper input-wrapper"
                                key={count}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexDirection: { xs: 'column', sm: 'row' },
                                  gap: 1,
                                  mb: 2,
                                }}
                              >
                                {/* <SelectComponent
                                    name="careerHistory"
                                    placeholder="Start typing to find a job title..."
                                    selectOptions={CareerOptions.filter(option => !(currentRole.length > 0 ? currentRole : CareerHistoryState).some(opt => opt.value === option.value))}
                                    value={currentRole[count]} handleChange={(e) => handleChange(count, e)}
                                    showError={showError} errorMessage='Please select atleast one career to identify your skills'
                                    /> */}
                                <CareerAutoComplete
                                  key={`autocomplete-${count}`}
                                  value={currentRole[count] || null}
                                  onChange={(value) => {
                                    if (value) {
                                      handleChange(count, { value: value._id, label: value.title });
                                    } else {
                                      handleChange(count, null);
                                    }
                                  }}
                                  placeholder="Start typing to find a job title..."
                                  loading={fieldLoading[count]}
                                  fieldIndex={count}
                                  buttonColor={buttonColor}
                                  componentsProps={{
                                    clearIndicator: {
                                      sx: {
                                        display: currentRole.length > 1 ? 'none' : 'flex',
                                      },
                                    },
                                  }}
                                  sx={{
                                    width: { xs: '100%', sm: 350, md: 400 },
                                  }}
                                />
                                {index > 0 ? (
                                  <Button
                                    className="icon-btn less"
                                    onClick={() => removeField(count)}
                                    sx={{
                                      minWidth: 36,
                                      height: 36,
                                      ml: { xs: 0, sm: 1 },
                                      mt: { xs: 1, sm: 0 },
                                    }}
                                  >
                                    <span style={{ border: '2px solid #fff', color: '#fff' }}>
                                      -
                                    </span>
                                  </Button>
                                ) : (
                                  ''
                                )}
                              </Box>
                            ))}

                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                pt: { xs: 2, md: 5 },
                                gap: { xs: 2, sm: 0 },
                              }}
                              className="addField-btn-wrapper"
                            >
                              <Button
                                fullWidth
                                sx={{
                                  justifyContent: { xs: 'center', sm: 'flex-start' },
                                  mb: { xs: 1, sm: 0 },
                                }}
                                className="icon-btn noUppercase addField"
                                onClick={addField}
                              >
                                <span
                                  style={{
                                    backgroundColor: buttonColor || 'transparent',
                                    color: buttonFontColor || 'white',
                                    width: 40,
                                    height: 40,
                                    fontSize: 28,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    marginRight: 12,
                                  }}
                                >
                                  +
                                </span>
                                <Typography
                                  sx={{
                                    color: (theme) => fontColor || theme?.primary?.white,
                                    fontWeight: 700,
                                  }}
                                >
                                  Add another role
                                </Typography>
                              </Button>
                              <Button
                                fullWidth
                                sx={{
                                  backgroundColor: (theme) =>
                                    `${buttonColor || theme.palette.secondary.main} !important`,
                                  borderRadius: '8px',
                                  color: buttonFontColor || 'white',
                                  p: 2,
                                  mb: 2,
                                  mt: { xs: 1, sm: 0 },
                                }}
                                onClick={() => {
                                  const validRoles = currentRole.filter((role) => role?.value);

                                  localStorage.setItem(
                                    'region-career-history',
                                    JSON.stringify(validRoles)
                                  );

                                  dispatch(addCareerHistory(validRoles));
                                  handleClickReskill();
                                }}
                                disabled={!currentRole?.some((role) => role?.value)}
                              >
                                Continue
                              </Button>
                            </Box>

                          </Box>
                        </>
                      )}
                      {innerStepCount === 1 && (
                        <>
                          <Typography
                            variant="h2"
                            color="primary.white"
                            sx={{
                              fontSize: { xs: '24px', sm: '32px' },
                              textAlign: { xs: 'center', sm: 'left' },
                              mb: 2,
                            }}
                          >
                            What are you here to do today?
                          </Typography>
                          <Box
                            className="btn-wrapper role-select"
                            sx={{
                              display: 'flex',
                              flexDirection: { xs: 'column', sm: 'row' },
                              gap: 2,
                              alignItems: 'center',
                              justifyContent: { xs: 'center', sm: 'flex-start' },
                              mb: 2,
                            }}
                          >
                            <Button
                              className="btn"
                              aria-describedby="career-goal"
                              sx={{
                                backgroundColor: (theme) =>
                                  selectedRole === 'upskill' &&
                                  `${buttonColor || theme.palette.secondary.main} !important`,
                                border: (theme) =>
                                  selectedRole === 'upskill'
                                    ? `2px solid ${theme.palette.secondary.main}`
                                    : '2px solid #fff',
                                width: { xs: '100%', sm: 180 },
                              }}
                              onClick={() => setSelectedRole('upskill')}
                            >
                              <Typography variant="button2" color="#fff">
                                UPSKILL
                              </Typography>
                            </Button>
                            <Button
                              className="btn"
                              aria-describedby="career-goal"
                              sx={{
                                backgroundColor: (theme) =>
                                  selectedRole === 'reskill' &&
                                  `${buttonColor || theme.palette.secondary.main} !important`,
                                border: (theme) =>
                                  selectedRole === 'reskill'
                                    ? `2px solid ${theme.palette.secondary.main}`
                                    : '2px solid #fff',
                                width: { xs: '100%', sm: 180 },
                              }}
                              onClick={() => setSelectedRole('reskill')}
                            >
                              <Typography variant="button2" color="#fff">
                                RESKILL
                              </Typography>
                            </Button>
                          </Box>
                          <Box
                            className="step-content"
                            sx={{
                              textAlign: { xs: 'center', sm: 'left' },
                              mb: 2,
                            }}
                          >
                            {selectedRole === 'upskill' && (
                              <Typography variant="body2" color="primary.white">
                                Level up my career and improve my skills
                              </Typography>
                            )}
                            {selectedRole === 'reskill' && (
                              <Typography variant="body2" color="primary.white">
                                Change up my career and transfer my skills
                              </Typography>
                            )}
                          </Box>
                        </>
                      )}
                      {innerStepCount === 2 && (
                        <>
                          <Typography
                            variant="h2"
                            color="primary.white"
                            sx={{
                              fontSize: { xs: '24px', sm: '32px' },
                              textAlign: { xs: 'center', sm: 'left' },
                              mb: 1,
                            }}
                          >
                            Do you have a career goal?
                          </Typography>
                          <Typography
                            variant="capitalize"
                            color="primary.white"
                            sx={{
                              textAlign: { xs: 'center', sm: 'left' },
                              mb: 2,
                            }}
                          >
                            Optional
                          </Typography>
                          <Box
                            className="step-content-wrapper"
                            sx={{
                              textAlign: { xs: 'center', sm: 'left' },
                            }}
                          >
                            <Typography variant="bold" color="primary.white">
                              Are you aiming for a particular role in the future?
                            </Typography>
                            <Typography variant="body1" color="primary.white" sx={{ mb: 2 }}>
                              If so, you can enter that here to see where upskilling may be required
                              to help you achieve it successfully. <br />
                              This UPSKILL search is limited to roles in the same sector as your
                              current role.
                              <br /> If the role you are aiming for is in a different sector you
                              should go back and select 'Reskill'
                            </Typography>
                            {!careersGoalsLoading ? (
                              <Box className="field-wrapper" sx={{ maxWidth: 400, mx: 'auto' }}>
                                <SelectComponent
                                  name="careerGoal"
                                  placeholder="Start typing to find a job title..."
                                  selectOptions={CareerGoals}
                                  value={careerGoal}
                                  handleChange={(e) => setCareerGoal(e)}
                                />
                              </Box>
                            ) : (
                              <Box sx={{ display: 'flex', justifyContent: 'center', mt: '24px' }}>
                                <CircularProgress sx={{ color: '#fff !important' }} />
                              </Box>
                            )}
                          </Box>
                        </>
                      )}
                    </Box>
                    <Button
                      className="step-btn next"
                      disabled={
                        innerStepCount === 1 && !selectedRole ? disabledBtn.true : disabledBtn.false
                      }
                      sx={{
                        overflow: 'hidden',
                        height:
                          selectedRole !== 'reskill' &&
                            innerStepCount !== 2 &&
                            currentRole?.length > 0
                            ? 'auto'
                            : 0,
                        color: (theme) => buttonColor || theme.palette.secondary.main,
                        minWidth: { xs: 36, md: 48 },
                        alignSelf: { xs: 'flex-end', md: 'center' },
                        mt: { xs: 2, md: 0 },
                      }}
                      onClick={handleClickReskill}
                    >
                      <ArrowForwardIosIcon />
                    </Button>
                  </Box>
                  <Box
                    className="btn-wrapper career-history"
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      gap: 2,
                      mt: { xs: 2, md: 4 },
                      justifyContent: { xs: 'center', sm: 'flex-end' },
                    }}
                  >
                    {selectedRole === 'reskill' && innerStepCount === 1 && (
                      <Button
                        className="btn noUppercase handleHover"
                        sx={{
                          backgroundColor: (theme) =>
                            `${buttonColor || theme.palette.secondary.main} !important`,
                          width: { xs: '100%', sm: 'auto' },
                        }}
                        aria-describedby="career-goal"
                        onClick={handleClickReskill}
                      >
                        <Typography
                          variant="button2"
                          color="primary.white"
                          sx={{ display: 'flex', alignItems: 'center' }}
                        >
                          Analyse my skills{' '}
                          <ArrowForwardIosRoundedIcon fontSize="20px" sx={{ marginLeft: '20px' }} />
                        </Typography>
                      </Button>
                    )}
                    {innerStepCount === 2 && (
                      <Button
                        className="btn noUppercase handleHover"
                        sx={{
                          backgroundColor: (theme) =>
                            `${buttonColor || theme.palette.secondary.main} !important`,
                          width: { xs: '100%', sm: 'auto' },
                        }}
                        aria-describedby="career-goal"
                        onClick={handleClickUpskill}
                      >
                        <Typography
                          variant="button2"
                          color="primary.white"
                          sx={{ display: 'flex', alignItems: 'center' }}
                        >
                          Analyse my skills{' '}
                          <ArrowForwardIosRoundedIcon fontSize="20px" sx={{ marginLeft: '20px' }} />
                        </Typography>
                      </Button>
                    )}
                  </Box>
                </>
              ) : (
                <Box sx={{ position: 'absolute', top: '42%', left: '48%' }}>
                  <CircularProgress />
                </Box>
              )}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}
